import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@Shared/components/general/page-header.vue";
import SupportItem from "./support-item.vue";
import SupportLoader from "./support-loader.vue";
import Navbar from "@Shared/components/general/nav-bar.vue";
import { mapActions, mapState } from "vuex";
import { LOAD_CLIENT_FAQ } from "../store/support-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SupportContainer",
  title() {
    return this.$t("sidebar.sections.support");
  },
  components: {
    PageHeader,
    SupportItem,
    Navbar,
    SupportLoader
  },
  data() {
    return {
      search: "",
      loading: false,
      currentTab: "general"
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("SupportStore", ["faq"])), {}, {
    tabs() {
      return [{
        label: this.$t("support.tabs.generalInquiry"),
        value: "general"
      }, {
        label: this.$t("support.tabs.support"),
        value: "support"
      }];
    },
    filterBySearch() {
      return this.search !== "";
    },
    filteredFAQ() {
      var _context, _context4;
      return this.filterBySearch ? _filterInstanceProperty(_context = this.faq).call(_context, question => {
        var _context2, _context3;
        return _includesInstanceProperty(_context2 = question.question.toLowerCase()).call(_context2, this.search.toLowerCase()) || _includesInstanceProperty(_context3 = question.answer.toLowerCase()).call(_context3, this.search.toLowerCase());
      }) : _filterInstanceProperty(_context4 = this.faq).call(_context4, question => question.category === this.currentTab);
    }
  }),
  async mounted() {
    this.loading = true;
    await this.LOAD_CLIENT_FAQ();
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("SupportStore", [LOAD_CLIENT_FAQ])), {}, {
    handleTabChange(tab) {
      this.currentTab = tab;
    }
  })
});